<template>
  <div>
    <sidebar-body-header icon="mdi-magnify" :name="$i18n.t('sidebar.search')" hide-expanding />
    <div class="sidebar-search-body text-center pa-5">
      <img :src="require(`@/assets/images/map.png`)" class="mb-5" />
      <p class="primary--text font-weight-medium mb-5">{{ $i18n.t('sidebar.searchArea') }}</p>
      <p class="font-size-14 mb-5">{{ $i18n.t('sidebar.searchAreaHint') }}</p>
      <base-button text="buttons.goToSearch" color="secondary" @click="isSearchDialogVisible = true" />
    </div>
    <sidebar-search-dialog
      v-if="isSearchDialogVisible"
      :is-visible.sync="isSearchDialogVisible"
      :payload.sync="filterPayload"
    />
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';
import SidebarBodyHeader from '@/components/sidebar/SidebarBodyHeader';
import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'SidebarSearch',
  components: {
    SidebarBodyHeader,
    BaseButton,
    SidebarSearchDialog: () => import('@/components/sidebar/SidebarSearchDialog'),
  },
  computed: {
    filterPayload: sync('map/filterPayload'),
  },
  data: () => ({
    isSearchDialogVisible: false,
    payload: {},
  }),
};
</script>
<style lang="scss" scoped>
.sidebar-search-body {
  background-color: #262e3e1a;
}
</style>
